import { State, getLanguage } from '@cemex/cmx-client-layout';
import { Store, select } from '@ngrx/store';
import { CX_INPUT_DATE_LANGUAGE_TOKEN } from 'app/shared/cx-ui/cx-input-date/cx-input-date.config';
import { distinctUntilChanged, shareReplay } from 'rxjs/operators';

export const cxDateLanguageProvider = {
  provide: CX_INPUT_DATE_LANGUAGE_TOKEN,
  deps: [Store],
  useFactory: (store: Store<State>) => {
    return store.pipe(select(getLanguage), distinctUntilChanged(), shareReplay());
  },
};
